import { create } from 'zustand';
import type { ProjectDetail } from './types';

interface SelectedProjectState {
  project: ProjectDetail | null;
}

const useSelectedProjectStore = create<SelectedProjectState>(() => ({
  project: null,
}));

export const useSelectedProject = () => useSelectedProjectStore((state) => state.project);

export const setSelectedProject = (project: ProjectDetail | null): void => {
  useSelectedProjectStore.setState({ project });
};
